import './App.css';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import { useEffect, useState } from 'react';
import MainPage from './Pages/MainPage/MainPage';
import Loading from './Pages/Loading/Loading';
import ErrorPage from './Shared/ErrorPage/ErrorPage';
// import Gallery from './Pages/Gallery/Gallery';


function App() {

  const [loading, setLoading] = useState(false);


  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000)
  }, []);

  

  window.addEventListener("contextmenu", function (click) {
    click.preventDefault();
  });


  return (
    <>
      {
        loading ?
        <Loading/>
          :
          <BrowserRouter>
            <Routes>
              <Route index path="/" element={<MainPage />} />
              <Route path="/home" element={<MainPage/>} />
              <Route path="*" element={<ErrorPage />} />
              {/* <Route path="/gallery" element={<Gallery/>} /> */}
            </Routes>
          </BrowserRouter>
      }
    </>

  );
}

export default App;

